module.exports = __webpack_public_path__ + "static/img/fivestar_th.e2dc8a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/fivestar_th.png
// module id = WTyc
// module chunks = 1